import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
};

export type PreviewCancelReservationResponse = {
  data: {
    cancellationWindow: string;
    refundAmount: number;
    creditOnlySelected: boolean;
    creditPaid: number;
    cardPaid: number;
  };
};

export const usePreviewCancelReservation = createMutation<
  PreviewCancelReservationResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/cancel-preview`,
      method: 'GET',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
